import { render, staticRenderFns } from "./ShareholdersTable.vue?vue&type=template&id=e303371c"
import script from "./ShareholdersTable.vue?vue&type=script&lang=js"
export * from "./ShareholdersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports